const fileDom = document.getElementById('fileUpload');
if (fileDom) {
    fileDom.onchange = (event) => {
        const fileNameDom = document.getElementById('fileNameDom');

        document.body.contains(fileNameDom) && fileNameDom.remove();

        const fileValue = event.target.files[0];
        let fileName = fileValue.name;

        fileDom.insertAdjacentHTML('afterend', '<div id="fileNameDom" class="fileName">' + fileName + '</div>');
    }
}
